// 计算文件大小处理器
function calcSizeHander(size, step, currStep, unit){
  const calcRes = size / currStep
  if(calcRes > 1 && calcRes < step){
    return { code: 0, res: `${calcRes.toFixed(2)}<span class="unit">${unit}</span>`}
  }
  currStep *= step
  return { code: 1, res: currStep}
}

// 文档类型匹配处理器
function matchType(name){
  const suffix = getSuffix(name)
  if(!suffix) return
  for(let i = 0 ; i < typeOptions.length ; i++){
    const typeOption = typeOptions[i]
    if(typeOption.suffixs.indexOf(suffix) != -1){
      return typeOption
    }
  }
  return null
}

// 获取后缀名
function getSuffix(name){
  if(!name) return null
  let suffix = name.substring(name.lastIndexOf('.') + 1, name.length)
  if(!suffix) return null
  suffix = suffix.toLowerCase()
  return suffix
}

/**
 * 文件类型配置
 */
const typeOptions = [
  {
    suffixs: ['jpg', 'jpeg', 'png',  'gif',  'ico', 'bmp'],
    icon: require('@/static/icons/document/image.png'),
    type: "IMG"
  },{
    suffixs: ['pdf'], 
    icon: require('@/static/icons/document/pdf.png'),
    type: "PDF"
  },
  {
    suffixs: ['dwg', 'dxf', 'dwf'],
    icon: require('@/static/icons/document/cad.png'),
    type: "CAD"
  },
  {
    suffixs: ['doc', 'docx'],
    icon: require('@/static/icons/document/word.png'),
    type: "WORD"
  },
  {
    suffixs: ['xls', 'xlsx'],
    icon: require('@/static/icons/document/excel.png'),
    type: "EXCEL"
  },{
    suffixs: ['ppt', 'pptx'],
    icon: require('@/static/icons/document/ppt.png'),
    type: "PPT"
  },{
    suffixs: ['mp4'],
    icon: require('@/static/icons/document/viedo.png'),
    type: "VIDEO"
  },{
    suffixs: ['txt', 'log', 'xml', 'sql'], 
    icon: require('@/static/icons/document/txt.png'),
    type: "TXT"
  },{
    suffixs: ['stp'], 
    icon: require('@/static/icons/document/image.png'),
    type: "STP"
  },
]

export default {
  // 计算文件大小
  calcSize(size){
    if(!size) return '计算失败'
    let step = 1024
    let currStep = 1
    size = Number(size)
    size *= step
    let unitList = ['B', 'K', 'M', 'G', 'T']
    for(let i = 0 ; i < unitList.length ; i++){
      const {code, res} = calcSizeHander(size, step, currStep, unitList[i])
      if(code === 0) return res
      if(code === 1) currStep = res
    }
    return '计算失败'
  },
  // 文档类型图标处理
  docIconHandler(name){
    const unknowIcon = require(`@/static/icons/document/unknown.png`)
    const typeOption = matchType(name)
    if(!typeOption) return unknowIcon
    // 未知类型图标
    return typeOption.icon
  },
  // 获取文档类型
  getDocType(name){
    const typeOption = matchType(name)
    if(!typeOption) return null
    return typeOption.type
  },
  getSuffix
}